import { useRef, useState } from 'react';
import { type IPendingTransaction } from '@recargas-dominicanas/core/types';
import { formatCurrency, formatDate } from '@recargas-dominicanas/core/utils';
import { TableRow, Cell, CellIcon, Menu } from '@recargas-dominicanas/core/components';
import { PendingTransactionModal } from '../pending-transaction-modal/pending-transaction-modal.component';
import { RegisterPendingDepositModal } from '../register-pending-deposit-modal/register-pending-deposit-modal.component';
import { RegisterPendingWithdrawalModal } from '../register-pending-withdrawal-modal/register-pending-withdrawal-modal.component';
import { LinkPendingWithdrawalModal } from '../link-pending-withdrawal-modal/link-pending-withdrawal-modal.component';
import { LinkPendingDepositModal } from '../link-pending-deposit-modal/link-pending-deposit-modal.component';
import { MenuOption } from '../../../../components/menu-option/menu-option.component';

import { 
  RegisterPendingProfitWithdrawalModal 
} from '../register-pending-profit-withdrawal-modal/register-pending-profit-withdrawal-modal.component';

import { style } from './pending-transaction-item.module.css';

interface Props {
  bankAccountId: number;
  pendingTransaction: IPendingTransaction;
}

export function PendingTransactionItem(props: Props) {

  const { bankAccountId, pendingTransaction } = props;

  const registered = pendingTransaction.status === 'registered';
  const menuIconRef = useRef<HTMLDivElement>(null);
  const [openMenu, setOpenMenu] = useState(false);
  const [openPendingTransactionModal, setOpenPendingTransactionModal] = useState(false);
  const [openRegisterPendingDepositModal, setOpenRegisterPendingDepositModal] = useState(false);
  const [openRegisterPendingWithdrawalModal, setOpenRegisterPendingWithdrawalModal] = useState(false);
  const [openRegisterPendingProfitWithdrawalModal, setOpenRegisterPendingProfitWithdrawalModal] = useState(false);
  const [openLinkPendingDepositModal, setOpenLinkPendingDepositModal] = useState(false);
  const [openLinkPendingWithdrawalModal, setOpenLinkPendingWithdrawalModal] = useState(false);

  function handleOpenRegisterModal() {
    if (pendingTransaction.type === 'deposit') setOpenRegisterPendingDepositModal(true);
    if (pendingTransaction.type === 'withdrawal') setOpenRegisterPendingWithdrawalModal(true);
    setOpenMenu(false);
  }

  function handleOpenRegisterProfitModal() {
    setOpenRegisterPendingProfitWithdrawalModal(true);
    setOpenMenu(false);
  }

  function handleOpenLinkModal() {
    if (pendingTransaction.type === 'deposit') setOpenLinkPendingDepositModal(true);
    if (pendingTransaction.type === 'withdrawal') setOpenLinkPendingWithdrawalModal(true);
    setOpenMenu(false);
  }

  return (
    <TableRow
      onClick={() => setOpenPendingTransactionModal(true)}>
      <Cell text={pendingTransaction.type === 'deposit' ? 'Deposito' : 'Retiro'}/>
      <Cell weight='medium' color='green' text={formatCurrency(pendingTransaction.balance)}/>
      <Cell text={formatDate(pendingTransaction.creationDate)}/>
      {!registered &&
        <Cell text={'No registrado'} color='gray' weight='medium'/>
      }
      {registered &&
        <Cell text={'Registrado'} color='green' weight='medium'/>
      }
      <Cell className={style.description} text={pendingTransaction.description}/>
      <CellIcon
        refIcon={menuIconRef}
        icon='more_horiz'
        onClick={() => setOpenMenu(true)}/>
      <Menu 
        open={openMenu} 
        anchor={menuIconRef}
        onClose={() => setOpenMenu(false)}>
        <MenuOption 
          text='Registrar'
          disabled={registered}
          onClick={handleOpenRegisterModal}/>
        {pendingTransaction.type === 'withdrawal' &&
          <MenuOption 
            text='Registrar como gasto'
            disabled={registered}
            onClick={handleOpenRegisterProfitModal}/>
        }
        <MenuOption 
          text='Enlazar'
          disabled={registered}
          onClick={handleOpenLinkModal}/>
      </Menu>
      <PendingTransactionModal
        open={openPendingTransactionModal}
        pendingTransaction={pendingTransaction}
        onClose={() => setOpenPendingTransactionModal(false)}/>
      <RegisterPendingDepositModal
        open={openRegisterPendingDepositModal}
        bankAccountId={bankAccountId}
        pendingTransaction={pendingTransaction}
        onClose={() => setOpenRegisterPendingDepositModal(false)}/>
      <RegisterPendingWithdrawalModal
        open={openRegisterPendingWithdrawalModal}
        bankAccountId={bankAccountId}
        pendingTransaction={pendingTransaction}
        onClose={() => setOpenRegisterPendingWithdrawalModal(false)}/>
      <RegisterPendingProfitWithdrawalModal
        open={openRegisterPendingProfitWithdrawalModal}
        bankAccountId={bankAccountId}
        pendingTransaction={pendingTransaction}
        onClose={() => setOpenRegisterPendingProfitWithdrawalModal(false)}/>
      <LinkPendingDepositModal
        open={openLinkPendingDepositModal}
        bankAccountId={bankAccountId}
        pendingTransaction={pendingTransaction}
        onClose={() => setOpenLinkPendingDepositModal(false)}/>
      <LinkPendingWithdrawalModal
        open={openLinkPendingWithdrawalModal}
        bankAccountId={bankAccountId}
        pendingTransaction={pendingTransaction}
        onClose={() => setOpenLinkPendingWithdrawalModal(false)}/>
    </TableRow>
  );
}
